import { TablePaginationConfig } from 'antd/lib/table';
import { Page } from '../model/elements';

class TableService {
    readonly pageSize = 100;

    createPagination = (
        pageItems?: Page<any>,
        options?: { position?: TablePaginationPosition[]; pageSize?: number },
    ): TablePaginationConfig => {
        const pageSize = options?.pageSize || this.pageSize;
        return {
            current: pageItems ? pageItems.number + 1 : 1,
            total: pageItems && pageItems.totalElements > 0 ? pageItems.totalElements : pageSize,
            pageSize: pageSize,
            showSizeChanger: false,
            size: 'small',
            hideOnSinglePage: false,
            position: options?.position || ['bottomRight'],
        };
    };

    createDynamicPagination = (
        pageItems?: Page<any>,
        options?: { position?: TablePaginationPosition[]; pageSize?: number },
    ): TablePaginationConfig => {
        const pageSize = options?.pageSize || this.pageSize;
        return {
            current: pageItems ? pageItems.number + 1 : 1,
            total:
                pageItems && pageItems.numberOfElements > 0
                    ? pageItems.numberOfElements * pageItems.totalPages
                    : pageSize,
            pageSize: pageItems && pageItems.numberOfElements > 0 ? pageItems.numberOfElements : pageSize,
            showSizeChanger: false,
            size: 'small',
            hideOnSinglePage: false,
            position: options?.position || ['bottomRight'],
        };
    };

    createMemoryPagination = (
        items: any[],
        position?: TablePaginationPosition[],
        hideOnSinglePage?: boolean,
    ): TablePaginationConfig => {
        return {
            total: items && items.length > 0 ? items.length : this.pageSize,
            pageSize: this.pageSize,
            showSizeChanger: false,
            size: 'small',
            hideOnSinglePage: hideOnSinglePage || false,
            position: position || ['bottomRight'],
        };
    };
}

const tableService: TableService = new TableService();
export default tableService;

type TablePaginationPosition = 'topLeft' | 'topCenter' | 'topRight' | 'bottomLeft' | 'bottomCenter' | 'bottomRight';
